import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import GlobalModals from "src/components/Modal/GlobalModals";

const defaultPageDescription = "Bitcoin SV game platform - No Registration · Instant Payouts · Provable Fairness - "
  + "In-house games Powered by BSV blockchain.";

export default function PageContainer({
  showHeader,
  showFooter,
  children,
  pageTitle,
  pageDescription,
  dark,
  contentClass,
}) {
  const title = `${pageTitle} - Play Online Bitcoin Casino Games without Registration and No Deposit`;

  return (
    <>
      <Helmet bodyAttributes={{ style: dark && "background: #12033d;" }}>
        <title>{title}</title>
        <meta property="og:title" content={title} />
        <meta name="description" content={pageDescription} />
      </Helmet>
      <GlobalModals />
      {showHeader && <Header classes={dark ? ["transparent"] : []} />}
      <div className={contentClass}>{children}</div>
      {showFooter && <Footer />}
    </>
  );
}
PageContainer.propTypes = {
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  pageTitle: PropTypes.string.isRequired,
  pageDescription: PropTypes.string,
  dark: PropTypes.bool,
  contentClass: PropTypes.string,
};

PageContainer.defaultProps = {
  showHeader: true,
  showFooter: true,
  pageDescription: defaultPageDescription,
  dark: false,
  contentClass: null,
};
